import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useTranslation from 'next-translate/useTranslation';

// PropTypes
import { jobPropTypes } from '../../../../proptypes/jobProptypes';

// Context
import ApproachContext from '../../../../context/ApproachContext';

// Utils
import { langShorthand } from '../../../../utils';

// Styles
import styles from './whatYouBringSection.module.scss';

const WhatYouBringSection = ({ job }) => {
  const approach = useContext(ApproachContext);
  const { t } = useTranslation('common');

  if (
    // !job.extra_info?.travel &&
    !job.extra_info?.leadership_experience &&
    !job.talent_languages
  ) {
    return null;
  }

  // const isTravelRequired =
  //   job.extra_info?.travel && job.extra_info?.travel_importance === 'required';
  // const isLeadershipRequired = job.extra_info?.leadership_experience;
  // job.extra_info?.leadership_importance === 'required';
  const requiredLanguages =
    job.talent_languages?.filter(
      (language) => language.importance === 'required',
    ) || [];

  return (
    <section id="what-you-bring-section" className={styles.container}>
      <h2 className={styles.heading}>
        {t(`description_page.what_you_bring_section.title.${approach}`)}
      </h2>
      <div
        className={`html-div ${styles.content}`}
        dangerouslySetInnerHTML={{
          __html: job.extra_info?.requirements,
        }}
      />
      <div>
        <ul className={styles.list}>
          {/* {isTravelRequired && (
            <li>
              {t(
                `description_page.what_you_bring_section.travel_requirement.${approach}`,
              )}
              <span className={styles.separator}>:</span>{' '}
              {job.extra_info?.travel_details ||
                t(`questions_page.yes_no_values.yes.${approach}`)}
            </li>
          )} */}

          {/* {isLeadershipRequired && (
            <li>
              {t(
                `description_page.what_you_bring_section.experience.${approach}`,
              )}
              <span className={styles.separator}>:</span>{' '}
              {t(
                `description_page.what_you_bring_section.management_role.${approach}`,
              )}
            </li>
          )} */}

          {requiredLanguages.map((language) => (
            <li key={language.mid}>
              <span className={styles.language}>
                {language.display?.[langShorthand(job.job_language.mid)] ??
                  language.mid}
              </span>
              <span className={styles.separator}>:</span>{' '}
              {t(
                `description_page.language_proficiency.${language.level}.${approach}`,
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

WhatYouBringSection.propTypes = {
  job: PropTypes.shape(jobPropTypes).isRequired,
};

export default WhatYouBringSection;
